import React from "react";
import Writing from "../components/Writing";

const BlogsPage = () => <Writing />;

export default BlogsPage;
